import { TapiEndpointFactory } from '../baseQuery';

export const getCampaignQuotaStatsEndpoint: TapiEndpointFactory<'V1CampaignsCampaignQuotaStatsDetail'> =
  (builder) =>
    builder.query({
      query: ({ campaignId }) =>
        `/campaigns/${campaignId}/campaign_quota_stats`,
    });
